import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "../i18n/useLocale";
import SocialLinks from "./SocialLinks";
import WordmarkFlip from "./WordmarkFlip";
import { useDemoBooking } from "./DemoBookingDialog";

const SOLUTION_GROUPS = [
  { key: "work", ids: ["action-pro", "action-wi"] },
  { key: "buildings", ids: ["smart-toilet", "life-sense"] },
  { key: "displays", ids: ["esg-display", "wayfinding"] },
];

const Footer = () => {
  const { t } = useTranslation();
  const { path } = useLocale();
  const { openBooking } = useDemoBooking();

  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <nav className="footer-col footer-col-wide" aria-label={t("nav.solutions")}>
          <h2 className="footer-label">{t("nav.solutions")}</h2>
          <div className="footer-groups">
            {SOLUTION_GROUPS.map((group) => (
              <div key={group.key}>
                <h3 className="footer-sub">{t(`footer.groups.${group.key}`)}</h3>
                <ul>
                  {group.ids.map((id) => (
                    <li key={id}>
                      <Link to={path(`/solutions#${id}`)}>{t(`products.items.${id}.tab`)}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </nav>

        <nav className="footer-col" aria-label={t("nav.footer")}>
          <h2 className="footer-label">{t("footer.company")}</h2>
          <ul>
            <li>
              <Link to={path("/")}>{t("nav.home")}</Link>
            </li>
            <li>
              <Link to={path("/about")}>{t("nav.about")}</Link>
            </li>
            <li>
              <button type="button" className="footer-text-btn" onClick={openBooking}>
                {t("nav.bookDemo")}
              </button>
            </li>
          </ul>
        </nav>

        <div className="footer-col">
          <h2 className="footer-label">{t("footer.contact")}</h2>
          <address className="footer-address">{t("footer.address")}</address>
          <ul>
            <li>
              <a href="tel:+85298559349">+852 9855 9349</a>
            </li>
            <li>
              <a href="mailto:sales@virpluz.io">sales@virpluz.io</a>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h2 className="footer-label">{t("footer.follow")}</h2>
          <SocialLinks />
          <h2 className="footer-label footer-label-gap">{t("footer.legal")}</h2>
          <ul>
            <li>
              <Link to={path("/privacy")}>{t("footer.privacy")}</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-mark">
        <p className="footer-word" aria-hidden="true">
          <WordmarkFlip story="full" play="inview" />
        </p>
        <p className="footer-rights">{t("footer.rights", { year: new Date().getFullYear() })}</p>
      </div>
    </footer>
  );
};

export default Footer;
